import React, { useEffect, useState } from "react";
import { post } from "../../../components/api";
import AutocompleteInput from "../../../components/AutocompleteInput";
import "./styles.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import RouteMap from "../../../components/loadMap";
import { SweetAlert } from "../../../helpers/helper";

const AddLoadForm = () => {
  const [origin, setOrigin] = useState({ lat: "", lng: "" });
  const [destination, setDestination] = useState({ lat: "", lng: "" });
  const [originAddress, setOriginAddress] = useState("");
  const [destinationAddress, setDestinationAddress] = useState("");
  const [originCity, setOriginCity] = useState("");
  const [destinationCity, setDestinationCity] = useState("");
  const [originState, setOriginState] = useState("");
  const [destinationState, setDestinationState] = useState("");
  const [productTypes, setProductTypes] = useState([]);
  const [bodyTypes, setBodyTypes] = useState([]);
  const [tyreSizes, setTyreSizes] = useState([]);
  const [rate, setRate] = useState("");
  const [remark, setRemark] = useState("");
  const [truckCapacities, setTruckCapacities] = useState([]);
  const [vehicleSize, setVehicleSize] = useState([]);
  const [selectedBodyType, setSelectedBodyType] = useState({
    value: "body_type",
    label: "Body Type",
  });
  const [loadingDate, setLoadingDate] = useState(new Date());
  const [deliveryDate, setDeliveryDate] = useState(new Date());
  const [selectedProduct, setSelectedProduct] = useState({
    value: "product_type",
    label: "Product Type",
  });
  const [selectedTyre, setSelectedTyre] = useState({
    value: "tyre_type",
    label: "Tyre Type",
  });
  const [selectedTruckCapacity, setSelectedTruckCapacity] = useState({
    value: "truck_capacity",
    label: "Truck Capacity",
  });
  const [selectedVehiclesize, setSelectedVehicleSize] = useState({
    value: "vehicle_size",
    label: "Vehicle Size",
  });

  const navigate = useNavigate();

  const handlePlaceSelected = (place, inputIdentifier) => {
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const coords = { lat, lng };
    const components = place?.address_components || [];

    const getComponent = (type) => {
      const comp = components.find((c) => c.types.includes(type));
      return comp ? comp.long_name : "";
    };

    const city =
      getComponent("locality") || getComponent("administrative_area_level_2");
    const state = getComponent("administrative_area_level_1");
    const fullAddress = place?.formatted_address || "";

    if (inputIdentifier === "origin") {
      setOrigin(coords);
      setOriginAddress(fullAddress);
      setOriginCity(city);
      setOriginState(state);
    } else {
      setDestination(coords);
      setDestinationAddress(fullAddress);
      setDestinationCity(city);
      setDestinationState(state);
    }
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      background: "rgba(242, 243, 244, 0.5)",
      border: "none",
      outline: "none",
      fontSize: "0.8rem",
    }),
    menuList: (base) => ({
      ...base,
      fontSize: "0.8rem",
    }),
  };

  useEffect(() => {
    // Fetch dynamic data when the form loads
    const fetchDropdownData = async () => {
      try {
        const response = await post("/company/ltms/get-ProductType", {});
        const response1 = await post("/company/ltms/get-BodyType", {});
        const response2 = await post("/company/ltms/get-TyreSize", {});

        if (response.status == 200) {
          const formattedData = response.data.map((item) => ({
            value: item.value,
            label: item.label,
            id: item._id,
          }));

          setProductTypes(formattedData);
        }
        if (response1.status === 200) {
          const formattedData = response1.data.map((item) => ({
            value: item.value,
            label: item.label,
            id: item._id,
          }));

          setBodyTypes(formattedData);
        }
        if (response2.status === 200) {
          const formattedData = response2.data.map((item) => ({
            value: item.value,
            label: item.label,
            id: item._id,
          }));

          setTyreSizes(formattedData);
        }
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchDropdownData();
  }, []);

  const fetchTruckCapacity = async (id) => {
    try {
      const response = await post(`/company/ltms/get-TruckCapacity/${id}`, {});

      if (response.status === 200) {
        setTruckCapacities(
          response.data
            .filter((item) => item.tyreSize.includes(id))
            .map((item) => ({
              value: item.value,
              label: item.label,
              id: item._id,
            }))
        );
      }
    } catch (error) {
      console.log(error.message || "error while fetching Truck Capacities");
    }
  };

  const fetchVehicleSize = async (id) => {
    try {
      const response = await post(`/company/ltms/get-VehicleSize/${id}`, {});
      if (response.status === 200) {
        const formattedData = response.data
          .filter((item) => item.tyreSize.includes(id))
          .map((item) => ({
            value: item.value,
            label: item.label,
            id: item._id,
          }));

        setVehicleSize(formattedData);
      }
    } catch (error) {
      console.log(error.message || "error while fetching Truck Capacities");
    }
  };

  const handleChange = (selectedOption, type) => {
    if (type == "BodyType") {
      setSelectedBodyType(selectedOption);
    } else if (type == "ProductType") {
      setSelectedProduct(selectedOption);
    } else if (type == "TyreType") {
      setSelectedTyre(selectedOption);
      setSelectedTruckCapacity({
        value: "truck_capacity",
        label: "Truck Capacity",
      });
      setSelectedVehicleSize({
        value: "vehicle_size",
        label: "Vehicle Size",
      });
      fetchTruckCapacity(selectedOption.id);
    } else if (type == "TruckCapacity") {
      setSelectedTruckCapacity(selectedOption);
      fetchVehicleSize(selectedTyre.id);
    } else if (type == "vehicleSize") {
      setSelectedVehicleSize(selectedOption);
    }
  };

  const addLoad = async () => {
    if (!originAddress) {
      SweetAlert("Please select Origin", true);
      return;
    }
    if (!destinationAddress) {
      SweetAlert("Please select Destination", true);
      return;
    }
    if (!selectedProduct.id) {
      SweetAlert("Please select Product Type", true);
      return;
    }
    if (!selectedBodyType.id) {
      SweetAlert("Please select Body Type", true);
      return;
    }
    if (!selectedTyre.id) {
      SweetAlert("Please select Tyre Type", true);
      return;
    }
    if (!selectedTruckCapacity.id) {
      SweetAlert("Please select Truck Capacity", true);
      return;
    }
    if (!selectedVehiclesize.id) {
      SweetAlert("Please select Vehicle Size", true);
      return;
    }
    if (!rate) {
      SweetAlert("Please enter Offered Rate", true);
      return;
    }
    const response = await post("/company/ltms/add/load", {
      fromCity: {
        name: originAddress,
        city: originCity,
        state: originState,
        coordinates: [origin.lat, origin.lng],
      },
      toCity: {
        name: destinationAddress,
        city: destinationCity,
        state: destinationState,
        coordinates: [destination.lat, destination.lng],
      },
      loadType: "FTL",
      loadingDate: loadingDate,
      deliveryDate: deliveryDate,
      productType: selectedProduct.id,
      bodyType: selectedBodyType.id,
      tyre: selectedTyre.id,
      truckCapacity: selectedTruckCapacity.id,
      vehicleSize: selectedVehiclesize.id,
      OfferedRate: rate,
      remarks: remark,
    });
    if (response.status === 200) {
      SweetAlert("Your form has been successfully submitted", false);
      setOriginAddress("");
      setDestinationAddress("");
      setOrigin({ lat: "", lng: "" });
      setDestination({ lat: "", lng: "" });
      setOriginCity("");
      setDestinationCity("");
      setOriginState("");
      setDestinationState("");
      setLoadingDate(new Date());
      setDeliveryDate(new Date());
      setBodyTypes({
        value: "body_type",
        label: "Body Type",
      });
      setSelectedProduct({
        value: "product_type",
        label: "Product Type",
      });
      setSelectedTyre({
        value: "tyre_type",
        label: "Tyre Type",
      });
      setSelectedTruckCapacity({
        value: "truck_capacity",
        label: "Truck Capacity",
      });
      setSelectedVehicleSize({
        value: "vehicle_size",
        label: "Vehicle Size",
      });
      setTimeout(() => {
        navigate("/company/loads");
      }, 1000);
    } else {
      SweetAlert(response.message || "error!!!", true);
    }
  };

  return (
    <>
      <div className="tripCalculatorWrapper page-specific">
        <div
          style={{
            textAlign: "start",
            fontSize: "30px",
            fontWeight: "500",
            color: "rgba(68, 88, 95, 1)",
          }}
        >
          <p className="mb-0">Add Load</p>
        </div>
        <div className="row">
          <div className="col-md-5 col-lg-5" style={{ padding: "10px" }}>
            <div className="tripFormLoad">
              <div style={{ display: "flex" }}>
                <div className="row" style={{ padding: "10px", width: "100%" }}>
                  <div className="col-md-12 col-lg-12">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">Select Origin</p>
                      <div className="selectWrapperFull">
                        <AutocompleteInput
                          name="origin"
                          value={originAddress}
                          onPlaceSelected={handlePlaceSelected}
                          onChange={(e) => setOriginAddress(e.target.value)}
                          className="userInputnew"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">
                        Select Destination
                      </p>
                      <div className="selectWrapperFull">
                        <AutocompleteInput
                          name="destination"
                          value={destinationAddress}
                          onPlaceSelected={handlePlaceSelected}
                          onChange={(e) =>
                            setDestinationAddress(e.target.value)
                          }
                          className="userInputnew"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-6">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">
                        Enter Loading Date
                      </p>
                      <div
                        className="selectWrapperFull"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                        }}
                      >
                        <DatePicker
                          selected={loadingDate}
                          onChange={(date) => setLoadingDate(date)}
                          showTimeSelect
                          timeFormat="HH:mm"
                          minDate={Date.now()}
                          dateFormat={"dd/MM/yyyy HH:mm"}
                        />
                        <svg
                          width="17"
                          height="19"
                          viewBox="0 0 17 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginLeft: "-30px", zIndex: 9 }}
                        >
                          <path
                            d="M14.3333 2.6665H2.66667C1.74619 2.6665 1 3.4127 1 4.33317V15.9998C1 16.9203 1.74619 17.6665 2.66667 17.6665H14.3333C15.2538 17.6665 16 16.9203 16 15.9998V4.33317C16 3.4127 15.2538 2.6665 14.3333 2.6665Z"
                            stroke="#9CA7AC"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M11.833 1V4.33333"
                            stroke="#9CA7AC"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5.16699 1V4.33333"
                            stroke="#9CA7AC"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 7.6665H16"
                            stroke="#9CA7AC"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">
                        Enter Delivery Date
                      </p>
                      <div
                        className="selectWrapperFull"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                        }}
                      >
                        <DatePicker
                          selected={deliveryDate}
                          onChange={(date) => setDeliveryDate(date)}
                          showTimeSelect
                          timeFormat="HH:mm"
                          minDate={loadingDate || new Date()} // Delivery date must be after loading date
                          minTime={
                            deliveryDate &&
                            loadingDate &&
                            deliveryDate.toDateString() ===
                              loadingDate.toDateString()
                              ? new Date(loadingDate)
                              : new Date(new Date().setHours(0, 0, 0))
                          }
                          maxTime={new Date(new Date().setHours(23, 59, 59))}
                          dateFormat="dd/MM/yyyy HH:mm"
                          placeholder="Delivery Date"
                        />
                        <svg
                          width="17"
                          height="19"
                          viewBox="0 0 17 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginLeft: "-30px", zIndex: 9 }}
                        >
                          <path
                            d="M14.3333 2.6665H2.66667C1.74619 2.6665 1 3.4127 1 4.33317V15.9998C1 16.9203 1.74619 17.6665 2.66667 17.6665H14.3333C15.2538 17.6665 16 16.9203 16 15.9998V4.33317C16 3.4127 15.2538 2.6665 14.3333 2.6665Z"
                            stroke="#9CA7AC"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M11.833 1V4.33333"
                            stroke="#9CA7AC"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5.16699 1V4.33333"
                            stroke="#9CA7AC"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 7.6665H16"
                            stroke="#9CA7AC"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">
                        Enter Product Type
                      </p>
                      <div className="selectWrapperFull">
                        <Select
                          value={selectedProduct}
                          onChange={(e) => handleChange(e, "ProductType")}
                          options={productTypes}
                          defaultValue={{
                            value: "Toll_Type",
                            label: "Select Vehicle Toll Type",
                          }}
                          styles={customStyles}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">Select Body Type</p>
                      <div className="selectWrapperFull">
                        <Select
                          value={selectedBodyType}
                          onChange={(e) => handleChange(e, "BodyType")}
                          options={bodyTypes}
                          defaultValue={{
                            value: "Toll_Type",
                            label: "Select Vehicle Toll Type",
                          }}
                          styles={customStyles}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">Select Tyre Type</p>
                      <div className="selectWrapperFull">
                        <Select
                          value={selectedTyre}
                          onChange={(e) => handleChange(e, "TyreType")}
                          options={tyreSizes}
                          defaultValue={{
                            value: "Toll_Type",
                            label: "Select Vehicle Toll Type",
                          }}
                          styles={customStyles}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">
                        Select Truck Capacity
                      </p>
                      <div className="selectWrapperFull">
                        <Select
                          value={selectedTruckCapacity}
                          onChange={(e) => handleChange(e, "TruckCapacity")}
                          options={truckCapacities}
                          defaultValue={{
                            value: "Toll_Type",
                            label: "Select Vehicle Toll Type",
                          }}
                          styles={customStyles}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">
                        Select Vehicle Size
                      </p>
                      <div className="selectWrapperFull">
                        <Select
                          value={selectedVehiclesize}
                          onChange={(e) => handleChange(e, "vehicleSize")}
                          options={vehicleSize}
                          defaultValue={{
                            value: "Toll_Type",
                            label: "Select Vehicle Toll Type",
                          }}
                          styles={customStyles}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">Enter Rate</p>
                      <div className="selectWrapperFull">
                        <input
                          placeholder="Offered Rate"
                          value={rate}
                          onChange={(e) => setRate(e.target.value)}
                          className="userInputnew"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12">
                    <div className="formInputWrapper">
                      <p className="reportsFormLabel mb-1">Remark</p>
                      <div className="remarkContainer">
                        <textarea
                          placeholder="Remark"
                          value={remark}
                          onChange={(e) => setRemark(e.target.value)}
                          className="userInputnew remarkInput"
                        />
                        <div
                          style={{
                            background: "white",
                            position: "absolute",
                            right: "-5px",
                            bottom: "-5px",
                            padding: "8px 16px",
                            borderRadius: " 8px",
                            width: "136px",
                            height: "55px",
                          }}
                        >
                          <button className="submitButton" onClick={addLoad}>
                            <spna>Submit</spna>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    marginTop: "60px",
                    marginLeft: "-10px",
                  }}
                >
                  <svg
                    width="7"
                    height="82"
                    viewBox="0 0 7 99"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.02753 6.05188V92.7954"
                      stroke="#44585F"
                      strokeOpacity="0.2"
                      strokeWidth="1.01605"
                    />
                    <rect
                      x="0.508027"
                      y="0.508027"
                      width="5.03899"
                      height="5.03582"
                      stroke="#44585F"
                      strokeOpacity="0.4"
                      strokeWidth="1.01605"
                    />
                    <path
                      d="M5.54702 95.8213C5.54702 97.2117 4.41925 98.3392 3.02752 98.3392C1.63579 98.3392 0.508027 97.2117 0.508027 95.8213C0.508027 94.431 1.63579 93.3034 3.02752 93.3034C4.41925 93.3034 5.54702 94.431 5.54702 95.8213Z"
                      stroke="#44585F"
                      strokeOpacity="0.4"
                      strokeWidth="1.01605"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-7 col-lg-7" style={{ padding: "10px" }}>
            <RouteMap
              origin={{ lat: origin.lat, lng: origin.lng }}
              destination={{ lat: destination.lat, lng: destination.lng }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLoadForm;
